export default function(property) {
  switch (property) {
    case 'from':
    case 'fromWarehouse':
    case 'to':
    case 'toWarehouse':
    case 'parent':
    case 'article':
    case 'goods':
      return `${property}.shortName`
    case 'city':
    case 'type':
    case 'operationType':
      return `${property}.name`
    case 'contact':
      return `${property}.lastName`
    default:
      return property
  }
}
